import React, { useState } from "react";
import "./qualification.css";

const educationData = [
  {
    title: "Bachelor of Computer Science",
    subtitle: "University of Greenwich, UK",
    date: "2016 – 2021",
  },
  {
    title: "H.S.C",
    subtitle: "Cambrian College, Dhaka",
    date: "2012 – 2014",
  },
];

const experienceData = [
  {
    title: "PHP Developer",
    subtitle: "eFoli, LLC",
    date: "Jun 2023 – Present",
  },
  {
    title: "Full Stack Developer",
    subtitle: "BZM Graphics Limited",
    date: "Aug 2022 – May 2023",
  },
  {
    title: "Junior Laravel Developer",
    subtitle: "Di Mix World, Dhaka",
    date: "Jul 2021 – Jul 2022",
  },
  {
    title: "PHP Developer",
    subtitle: "UNITED TELEDOC, UK",
    date: "Jan 2021 – Jun 2021",
  },
];

const QualificationEntry = ({ entry, index, total }) => {
  const isLeft = index % 2 === 0;
  const isLast = index === total - 1;

  const content = (
    <div>
      <h3 className="qualification__title">{entry.title}</h3>
      <span className="qualification__subtitle">{entry.subtitle}</span>
      <div className="qualification__calender">
        <i className="uil uil-calender-alt"></i> {entry.date}
      </div>
    </div>
  );

  const timeline = (
    <div>
      <div className="qualification__rounder"></div>
      {!isLast && <span className="qualification__line"></span>}
    </div>
  );

  if (isLeft) {
    return (
      <div className="qualification__data">
        {content}
        {timeline}
      </div>
    );
  }

  return (
    <div className="qualification__data">
      <div></div>
      {timeline}
      {content}
    </div>
  );
};

const Qualification = () => {
  const [toggleState, setToggleState] = useState(2);

  const toggleTab = (index) => {
    setToggleState(index);
  };

  return (
    <section className="qualification section">
      <h2 className="section__title">Qualification</h2>
      <span className="section__subtitle">My Personal Journey</span>

      <div className="qualification__container container">
        <div className="qualification__tabs">
          <div
            className={
              toggleState === 1
                ? "qualification__button qualification__active button--flex"
                : "qualification__button button--flex"
            }
            onClick={() => toggleTab(1)}
          >
            <i className="uil uil-graduation-cap qualification__icon"></i>{" "}
            Education
          </div>

          <div
            className={
              toggleState === 2
                ? "qualification__button qualification__active button--flex"
                : "qualification__button button--flex"
            }
            onClick={() => toggleTab(2)}
          >
            <i className="uil uil-briefcase-alt qualification__icon"></i>{" "}
            Experience
          </div>
        </div>

        <div className="qualification__sections">
          <div
            className={
              toggleState === 1
                ? "qualification__content qualification__content-active"
                : "qualification__content"
            }
          >
            {educationData.map((entry, index) => (
              <QualificationEntry
                key={entry.subtitle + entry.date}
                entry={entry}
                index={index}
                total={educationData.length}
              />
            ))}
          </div>

          <div
            className={
              toggleState === 2
                ? "qualification__content qualification__content-active"
                : "qualification__content"
            }
          >
            {experienceData.map((entry, index) => (
              <QualificationEntry
                key={entry.subtitle + entry.date}
                entry={entry}
                index={index}
                total={experienceData.length}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Qualification;
